function AdministratoComponent($http, AppConstants) {
	'ngInject';

	const service = {
		fetchAdministrators: fetchAdministrators,
		fetchAdministrator: fetchAdministrator,
		getAdministrators: getAdministrators,
		getAdministrator: getAdministrator,
		getPaginationInfo: getPaginationInfo,
		createAdministrator: createAdministrator,
		updateAdministrator: updateAdministrator,
		deleteAdministrator: deleteAdministrator
	};

	let administrators = [];
	let administrator = {};
	// Information for pagination, current_page, total(count of items), and per_page(items on page)
	const paginationInfo = {};

	return service;

	function fetchAdministrators(page = 1, sort = '-id') {
		return $http.get(`${AppConstants.apiUrl}/administrators`, {
			'params': {
				page,
				sort,
				'per_page': AppConstants.perPage
			}
		})
			.then(setAdministrators)
			.catch(failedRequest);
	}

	function fetchAdministrator(id) {
		return $http.get(`${AppConstants.apiUrl}/administrators/${id}`)
			.then(setAdministrator)
			.catch(failedRequest);
	}

	function setAdministrators(response) {
		paginationInfo.page_size = AppConstants.perPage;
		paginationInfo.page = response.data.current_page;
		paginationInfo.total = response.data.total;
		administrators = response.data.data;
		return administrators;
	}

	function setAdministrator(response) {
		administrator = response.data.data;
		return administrator;
	}

	function getAdministrators() {
		return administrators;
	}

	function getAdministrator() {
		return administrator;
	}

	function getPaginationInfo() {
		return paginationInfo;
	}

	function createAdministrator(params) {
		return $http.post(`${AppConstants.apiUrl}/administrators`, params)
			.then(successRequest)
			.catch(failedRequest);
	}

	function updateAdministrator(id, params) {
		return $http.put(`${AppConstants.apiUrl}/administrators/${id}`, params)
			.then(successRequest)
			.catch(failedRequest);
	}

	function deleteAdministrator(id) {
		return $http.delete(`${AppConstants.apiUrl}/administrators/${id}`)
			.then(successRequest)
			.catch(failedRequest);
	}

	function successRequest(response) {
		return response;
	}

	function failedRequest(requestError) {
		console.log(requestError);
		return requestError;
	}

}
export default AdministratoComponent;



/** WEBPACK FOOTER **
 ** ./client/components/administrator/administrator.service.js
 **/